export const NODE_TYPES = [
  { value: "start", label: "Start", color: "grey" },
  { value: "message", label: "Message", color: "blue" },
  { value: "question", label: "Question", color: "orange" },
  { value: "condition", label: "Condition", color: "purple" },
  { value: "end", label: "End", color: "red" },
];

export const DEFAULT_GRAPH = {
  version: 1,
  nodes: [
    { id: "start", type: "start" },
    {
      id: "welcome",
      type: "message",
      text: "Merhaba! Size nasıl yardımcı olabilirim?",
    },
    { id: "end", type: "end" },
  ],
  edges: [
    { from: "start", to: "welcome" },
    { from: "welcome", to: "end" },
  ],
};

export function newNodeId(prefix = "node") {
  return `${prefix}_${Date.now().toString(36)}`;
}
